// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { ua, labels as utilLabels } from '@seedplanner/shared-utils';
import { routes } from '@seedplanner/shared-web';
import { createApolloClient } from './createApolloClient';
import { createAppContext } from './createAppContext';
import { renderApp } from './renderApp';

export const render = () => {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const currentWindow = window as any;

  const userAgent = currentWindow.__USER_AGENT__;
  const labels = {
    ...ua.convertLabels(userAgent),
    [utilLabels.APP_VERSION]: currentWindow.__APP_VERSION__,
  };

  const apolloState = currentWindow.__APOLLO_STATE__;
  const apolloClient = createApolloClient({
    endpoint: routes.GRAPHQL,
    labels,
    apolloState: apolloState,
  });

  const appContext = createAppContext({
    environment: currentWindow.__ENV__,
    css: currentWindow.__CSS__,
    nonce: currentWindow.__NONCE__,
    options: currentWindow.__OPTIONS__,
    userAgent,
  });
  const initialLocalState = currentWindow.__INITIAL_LOGGED_IN_STATE__;
  const intitialUserState = currentWindow.__INITIAL_USER_STATE__;

  renderApp(appContext, apolloClient, initialLocalState, intitialUserState);
};
